import { useState } from "preact/hooks";
import { DEFAULT_TERMS } from "../terms";

interface Props {
  clientId: string;
  brandName: string;
  onAccept: () => void;
}

export function TermsModal({ brandName, onAccept }: Props) {
  const [checked, setChecked] = useState(false);
  const terms = DEFAULT_TERMS;

  return (
    <div class="terms" role="dialog" aria-modal="true" aria-labelledby="terms-title">
      <div class="terms-title" id="terms-title">
        {brandName ? `Before you chat with ${brandName}` : "Before you chat"}
      </div>

      <ul class="terms-summary">
        {terms.summary.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <label class="terms-checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) =>
            setChecked((e.target as HTMLInputElement).checked)
          }
        />
        <span>I have read and accept these terms.</span>
      </label>

      <button
        class="terms-accept"
        onClick={onAccept}
        disabled={!checked}
        aria-label="Accept terms and start chatting"
      >
        Start chatting
      </button>
    </div>
  );
}
